<script setup lang="ts">
import type { IconName } from "~/models/Content/ContentProductPageMediaTypes"

defineProps<{
  content: string
  passive?: boolean
  icon?: IconName | "repeat"
}>()
</script>

<template>
  <UBadge
    variant="outline"
    :passive="passive"
  >
    <UIcon
      v-if="icon"
      :name="icon"
      size="xs"
      class="inline-flex items-center [&>svg]:inline"
    />
    <span>{{ content }}</span><span class="sr-only">.</span>
  </UBadge>
</template>
